﻿(function () {
  'use strict';

  function initShippingPage() {
    var root = document.querySelector('#MainContent .gvfg-ship, .gvfg-ship-section-wrapper .gvfg-ship, #gvfgShippingPage');
    if (!root || root.dataset.gvfgShipInit === '1') return;
    root.dataset.gvfgShipInit = '1';
    root.classList.add('gvfg-ship--enhanced');

    var reveals = root.querySelectorAll('.gvfg-ship-reveal');
    function showReveal(el) {
      el.classList.add('is-visible');
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              showReveal(e.target);
              io.unobserve(e.target);
            }
          });
        },
        { threshold: 0.08, rootMargin: '0px 0px -20px 0px' }
      );
      reveals.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.92) showReveal(el);
        io.observe(el);
      });
    } else {
      reveals.forEach(showReveal);
    }
    setTimeout(function () {
      reveals.forEach(showReveal);
    }, 1200);

    var hero = root.querySelector('.gvfg-ship-hero');
    if (hero) {
      requestAnimationFrame(function () { hero.classList.add('is-visible'); });
    }

    root.querySelectorAll('.gvfg-ship-3d-card').forEach(function (card) {
      var inner = card.querySelector('.gvfg-ship-3d-card__inner');
      if (!inner) return;
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        inner.style.transform =
          'rotateX(' + (-y * 14) + 'deg) rotateY(' + (x * 14) + 'deg) translateZ(12px)';
      });
      card.addEventListener('mouseleave', function () {
        inner.style.transform = '';
      });
    });

    root.querySelectorAll('.gvfg-ship-nav__pill').forEach(function (pill) {
      pill.addEventListener('click', function (e) {
        var id = pill.getAttribute('data-section');
        var target = document.getElementById(id);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          root.querySelectorAll('.gvfg-ship-nav__pill').forEach(function (p) {
            p.classList.remove('is-active');
          });
          pill.classList.add('is-active');
        }
      });
    });

    root.querySelectorAll('.gvfg-ship-acc-item').forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        root.querySelectorAll('.gvfg-ship-acc-item[open]').forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });

    root.querySelectorAll('a[href^="#gvfg-ship-"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href').slice(1);
        var target = document.getElementById(id);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    var steps = root.querySelectorAll('[data-ship-step]');
    if (steps.length > 1) {
      var stepIdx = 0;
      var advanceStep = function () {
        steps.forEach(function (step, i) {
          step.classList.toggle('is-active', i === stepIdx);
        });
        stepIdx = (stepIdx + 1) % steps.length;
      };
      var timeline = root.querySelector('.gvfg-ship-timeline');
      if (timeline && 'IntersectionObserver' in window) {
        var stepTimer = null;
        var stepIo = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) {
            if (!stepTimer) stepTimer = setInterval(advanceStep, 2800);
          } else if (stepTimer) {
            clearInterval(stepTimer);
            stepTimer = null;
          }
        }, { threshold: 0.35 });
        stepIo.observe(timeline);
      }
    }
  }

  window.gvfgInitShippingPage = function (force) {
    if (force) {
      document.querySelectorAll('.gvfg-ship').forEach(function (el) {
        delete el.dataset.gvfgShipInit;
      });
    }
    initShippingPage();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShippingPage);
  } else {
    initShippingPage();
  }

  document.addEventListener('shopify:section:load', initShippingPage);
})();
